export default "__VITE_ASSET__xMq8nmzS__"